import React, { useMemo, useState } from "react";
import cn from "classnames";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";
import { PanelWembii } from "../../PanelWembii";
import { TitleWembii } from "../../TitleWembii";
import { useIntl } from "react-intl";
import FormFieldsView from "./FormFieldsView";
import { isCleanFormDesign } from "../../../../cores/webForm/constants/FormDesign.constant";
import {
  webFormFormSelector,
  webFormInputsSelector,
} from "../../../../cores/webForm/store/selector";

export default function FormPreview() {
  const intl = useIntl();
  const form = useSelector(webFormFormSelector);
  const inputs = useSelector(webFormInputsSelector);
  const [showSuccessfulMessage, setShowSuccessfulMessage] = useState(false);
  const isClean = isCleanFormDesign(form?.design);

  const previewInputs = useMemo(
    () => inputs.map((input) => ({ ...input, value: "" })),
    [inputs]
  );

  const previewKey = useMemo(
    () =>
      inputs
        .map(
          (input) =>
            `${input.id}:${input.type}:${input.placeholder}:${JSON.stringify(
              input.options ?? null
            )}`
        )
        .join("|"),
    [inputs]
  );

  const onFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setShowSuccessfulMessage(true);
    setTimeout(() => {
      setShowSuccessfulMessage(false);
    }, 2000);
  };

  if (!form) {
    return null;
  }

  return (
    <Container className="sticky-top p-0 z-index-50 web-form-editor-ai__preview-wrap">
      <PanelWembii shadow className="p-4 web-form-editor-ai__card web-form-editor-ai__preview-card">
        <TitleWembii Tag="h5" color="primary">
          {intl.formatMessage({ id: "app.socialMediaPost.preview" })}
        </TitleWembii>

        <FormFieldsView
          key={previewKey}
          form={form}
          inputs={previewInputs}
          showSuccessfulMessage={showSuccessfulMessage}
          className={cn(
            "d-flex flex-column align-items-center p-2 web-form-editor-ai__preview-form",
            { "web-form-editor-ai__preview-form--clean": isClean }
          )}
          innerClassName={cn("w-100 web-form-editor-ai__preview-inner", {
            "web-form-editor-ai__preview-inner--clean": isClean,
          })}
          onSubmit={onFormSubmit}
        />
      </PanelWembii>
    </Container>
  );
}
